var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
export var mobile = function (breakpoint) { return "only screen and (max-width: ".concat(breakpoint - 1, "px)"); };
export var visualPicker = {
    display: 'flex',
    flexWrap: 'wrap',
    width: '100%',
    gap: 8,
};
var itemBase = {
    backgroundColor: '#ffffff',
    border: "1px solid ".concat('#DFE4E8'),
    borderRadius: 8,
    boxSizing: 'border-box',
    display: 'flex',
    flexDirection: 'column',
    textAlign: 'left',
    position: 'relative',
    padding: 0,
    boxShadow: '0px 2px 4px 0.5px rgba(50, 62, 72, 0.08)',
};
export var itemColumns = function (columns) {
    var _a;
    return (_a = {
            flexBasis: "calc((100%/".concat(columns, ") - 12px)")
        },
        _a["@media ".concat(mobile('860'))] = {
            flexBasis: columns > 1 ? "calc((100%/".concat(columns - 1, ") - 12px)") : 'calc(100% - 12px)',
        },
        _a["@media ".concat(mobile('700'))] = {
            flexBasis: 'calc(100% - 12px)',
        },
        _a);
};
export var focus = {
    outline: "2px solid ".concat('#2B66D6'),
    outlineOffset: 1,
    borderRadius: 8,
    boxShadow: '0px 3px 6px 1px rgba(50, 62, 72, 0.08)',
    background: "linear-gradient(0deg, rgba(255, 255, 255, 0.32) 0%, rgba(255, 255, 255, 0.32) 100%), ".concat('#ffffff'),
    '.visual-picker-footer': {
        background: "linear-gradient(0deg, rgba(255, 255, 255, 0.32) 0%, rgba(255, 255, 255, 0.32) 100%), ".concat('#F2F5F7'),
    },
};
export var resetFocus = {
    outline: 'none',
};
export var item = __assign(__assign({}, itemBase), { ':hover:not(:disabled)': {
        background: "linear-gradient(0deg, rgba(255, 255, 255, 0.32) 0%, rgba(255, 255, 255, 0.32) 100%), ".concat('#ffffff'),
        boxShadow: '0px 3px 6px 1px rgba(50, 62, 72, 0.08)',
        cursor: 'pointer',
        '.visual-picker-footer': {
            background: "linear-gradient(0deg, rgba(255, 255, 255, 0.32) 0%, rgba(255, 255, 255, 0.32) 100%), ".concat('#F2F5F7'),
        },
    }, ':focus:not(:disabled)': focus, ':focus-visible:not(:disabled)': focus, ':active:not(:disabled)': {
        background: "linear-gradient(0deg, rgba(0, 0, 0, 0.02) 0%, rgba(0, 0, 0, 0.02) 100%), ".concat('#ffffff'),
        boxShadow: 'inset 0px 0px 4px 0.5px rgba(50, 62, 72, 0.08)',
        '.visual-picker-footer': {
            background: "linear-gradient(0deg, rgba(0, 0, 0, 0.02) 0%, rgba(0, 0, 0, 0.02) 100%), ".concat('#F2F5F7'),
        },
    } });
export var componentTop = {
    display: 'flex',
    flexGrow: 0,
    flexShrink: 0,
    width: '100%',
    boxSizing: 'border-box',
    padding: 16,
    columnGap: 12,
};
export var footer = {
    color: '#000000',
    fontSize: 12,
    fontWeight: '450',
    lineHeight: '150%',
    backgroundColor: '#F2F5F7',
    marginTop: 'auto',
    padding: "".concat(8, "px ").concat(16, "px"),
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    boxSizing: 'border-box',
    borderBottomLeftRadius: 8,
    borderBottomRightRadius: 8,
    border: "1px solid ".concat('#DFE4E8'),
    columnGap: 16,
};
export var footerDisabled = __assign(__assign({}, footer), { color: "".concat('#8E9AA3', " !important") });
export var footerLeft = {
    flexGrow: '1',
};
export var footerRight = {
    flexShrink: '1',
};
export var iconContainer = {
    position: 'relative',
    top: 2,
};
export var textContainer = {
    flexGrow: 1,
};
export var imageContainer = {
    left: 0,
    top: 0,
    height: 48,
    minWidth: 48,
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'center',
};
export var label = {
    fontSize: 16,
    fontWeight: 700,
    lineHeight: '150%',
    color: '#000000',
};
export var description = {
    color: '#323E48',
    fontSize: 14,
    lineHeight: '18px',
    paddingTop: 2,
    fontWeight: '450',
};
export var selected = __assign(__assign({}, item), { border: "2px solid ".concat('#003FB8'), background: '#F2F7FF', '& .vp-item-icon-2l34kj': {
        color: '#003FB8',
        fontSize: '24px !important', // override size-medium
    }, '.visual-picker-footer': {
        background: "linear-gradient(0deg, rgba(255, 255, 255, 0.00) 0%, rgba(255, 255, 255, 0.00) 100%), ".concat('#E5EFFF'),
    }, ':hover:not(:disabled)': {
        background: "linear-gradient(0deg, rgba(255, 255, 255, 0.32) 0%, rgba(255, 255, 255, 0.32) 100%), ".concat('#F2F7FF'),
        '.visual-picker-footer': {
            background: "linear-gradient(0deg, rgba(255, 255, 255, 0.32) 0%, rgba(255, 255, 255, 0.32) 100%), ".concat('#E5EFFF'),
        },
    }, ':focus:not(:disabled)': {
        background: "linear-gradient(0deg, rgba(255, 255, 255, 0.32) 0%, rgba(255, 255, 255, 0.32) 100%), ".concat('#F2F7FF'),
        boxShadow: '0px 3px 6px 1px rgba(50, 62, 72, 0.08)',
        '.visual-picker-footer': {
            background: "linear-gradient(0deg, rgba(255, 255, 255, 0.32) 0%, rgba(255, 255, 255, 0.32) 100%), ".concat('#E5EFFF'),
        },
    }, ':active:not(:disabled)': {
        background: "linear-gradient(0deg, rgba(0, 0, 0, 0.02)) 0%, rgba(0, 0, 0, 0.02)) 100%), ".concat('#F2F7FF'),
        boxShadow: 'inset 0px 0px 4px 0.5px rgba(50, 62, 72, 0.08)',
        '.visual-picker-footer': {
            background: "linear-gradient(0deg, rgba(0, 0, 0, 0.02) 0%, rgba(0, 0, 0, 0.02) 100%), ".concat('#E5EFFF'),
        },
    } });
export var selectedDisabled = {};
export var selectedIconContainer = {
    position: 'relative',
    top: 2,
    paddingLeft: 12,
};
export var disabled = __assign(__assign({}, itemBase), { borderColor: "".concat('#A8B2BA', " !important"), background: "".concat('#F2F5F7', " !important"), boxShadow: 'none !important', cursor: 'not-allowed !important', '.vp-item-description-2l34kj, .vp-item-user-icon-2l34kj, .visual-picker-label, [class*="pcty-icon"]': {
        color: "".concat('#8E9AA3', " !important"),
    } });
export var error = {
    border: "2px solid ".concat('#CC0821'),
};
export var itemImage = {
    width: '100%',
};
export var itemImageDisabled = {
    opacity: '20%',
};
export var imageCircle = {
    borderRadius: '50%',
};
export var imageSquare = {
    borderRadius: 0,
};
